export function hasNumber(string) {
    return /\d+/g.test(string);
}
